import { Avatar, Grid, IconButton, ListItem, ListItemAvatar, ListItemText, Paper, Typography } from "@mui/material";
import { styled } from "@mui/system";
import React, { useState } from "react";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import InquiryService from "../../services/inquiryService";
import PendingIcon from "@mui/icons-material/Pending";

const ChatItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: "#dbeee0",
  borderRadius: 10,
  padding: 2,
  boxShadow: "none",
  padding: "1px 0 1px 20px",
  width: "75%",
  marginBottom: "10px",
}));

const ChatRight = ({ feed, user }) => {
  const [isAccepted, setIsAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const acceptRequest = async () => {
    setIsLoading(true);
    await InquiryService.acceptInquiry(feed?.Inquiry?.id);
    setIsAccepted(true);
    setIsLoading(false);
  };
  return (
    <Grid container direction="row" justifyContent="flex-end" alignItems="space-between">
      {(!feed?.isAutoGenerated ||
        (feed?.isAutoGenerated && feed?.isAutoGenerated && feed?.Inquiry?.employeeCreated === user.id) ||
        (feed?.Inquiry?.employee !== null && user.id === feed?.Inquiry?.employee) ||
        (feed?.Inquiry?.department !== null && feed?.Inquiry?.department === user?.department)  ||
        feed?.employee===user.id ) && (
        <>
          {/* <ChatItem elevation={1}> */}
          {!isAccepted &&
            !isLoading &&
            feed?.isAutoGenerated &&
            !feed?.Inquiry?.isAccepted &&
            (user.id === feed?.Inquiry?.employee || feed?.Inquiry?.department === user?.department) && (
              <IconButton aria-label="delete" size="large" onClick={() => acceptRequest()}>
                <OfflineBoltIcon sx={{ color: "red" }} />
              </IconButton>
            )}
          {isLoading && (
            <IconButton aria-label="delete" size="large">
              <PendingIcon sx={{ color: "green" }} />
            </IconButton>
          )}
          <ChatItem
            alignItems="center"
            sx={{
              backgroundColor: !feed?.isAutoGenerated ? "#f0f8ff" : !feed?.Inquiry?.isAccepted ? "orange" : "green",
              color: feed?.isAutoGenerated ? "white" : "black",
            }}
          >
            <ListItemText
              primary={
                <React.Fragment>
                  <Typography
                    sx={{ color: feed?.isAutoGenerated ? "white" : "black", display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    {!feed?.isAutoGenerated && `${feed?.description}`}
                     {feed?.isAutoGenerated && (`Candidate : ${feed?.Inquiry?.name} ` || "")} <br></br>
                     {feed?.Inquiry?.remarks && (` Remark :  ${feed?.Inquiry?.remarks}` || "")}
                     {/* {feed?.Inquiry?.isAccepted && <>Accepted</>} */}
                    {/* {` — ${feed?.description}`} */}
                  </Typography>
                </React.Fragment>
                }
              secondary={
                <React.Fragment>
                  <Typography
                    sx={{ color: feed?.isAutoGenerated ? "white" : "black", display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.primary"
                  >
                    {feed?.isAutoGenerated && `Created by ${feed?.Employee?.name}`}
                    {/* {feed?.description} */}
                    {/* {` — ${feed?.description}`} */}
                  </Typography>
                </React.Fragment>
              }
            />
            <ListItemAvatar>
              <Avatar
                alt={feed?.isAutoGenerated ? "System generated" : feed?.Employee?.name}
                src={
                  feed?.isAutoGenerated
                    ? "/images/auto-gen.png"
                    : feed?.Employee?.imagePath || "/static/images/avatar/1.jpg"
                }
              />
            </ListItemAvatar>
          </ChatItem>

          {/* </ChatItem> */}
        </>
      )}
    </Grid>
  );
};

export default ChatRight;
